// extracted by mini-css-extract-plugin
export default {"f":"a2b29cbe40","main":"_689de29e52","btn":"_6ed59b25c3","w":"_047ee278f9","h":"eb8923124d","lh25":"_142f0fc677","wb":"d961e6b805","b":"_02fdbf9d22","bx":"a9b61ca0a6"};